"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//


exports.default = {
  props: {
    question: {
      type: Object,
      required: true
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/forms/elements/QuestionName.vue
// module id = OsaG
// module chunks = 0 1